export const headers = {
  X_AUTHORIZATION_EMAIL: 'x-authentication-email',
  AUTHORIZATION: 'Authorization',
  CONTENT_TYPE: 'Content-type'
};